import { EQuoteType } from "../../api/Types";

export const a = "";
export const solarAssessment = [
  "POV System Layout: 9 Panel Tier One System with Hybrid Invertor to future proof for potential storage battery installation at a later stage",
  "DC Cable Notes: Cable route internally from panels to invertor on attic gable wall",
  "AC Cable Notes: Cable route from invertor to attic to fuseboard location in front hallway. Route externally from soffits down along drain pipe and drill through to fuseboard",
  "Diverter: Eddit hot water diverter added to maximise consumption of solar energy produced, immersion may need to be replaced due to age, this can only be verified at install. As the immersion is not part of solar installation, the homeowner will be responsible for repair as discussed in home assessment.",
  "Free Monitoring: Yes",
  "Battery Ready: Yes",
  "Battery Provided: No",
  "SEAI Grant: Quote does not include SEAI grant of €2200 approximately (payable to customer after install)",
  "Payment Terms: Balance to be paid in full minimum 1 week prior to install date provided (TBC)",
  "Invertor Location: Solid attic wall beside alarm box. Floored and lighted",
  "Plant Delivery: Side Gate"
];

export const boilerAssessment = [
  "Disconnect and remove existing system boiler",
  "Fit new system boiler in same location",
  "New filter will be installed and will be located at boiler",
  "New condense pipe will be installed and will terminate at existing external waste",
  "Existing controls and operation will remain the same",
  "Boiler replacement only",
  "Press to be emptied to allow existing boiler removal and new boiler installation prior to installation"
];

export type CustomerSliderType = {
  customerMessage: string;
  customerName: string;
  customerImage: string;
};

export const customerSliderByType = (quoteType?: EQuoteType) => {
  switch (quoteType) {
    case EQuoteType.Boiler:
      return customerSliderBoiler;
    case EQuoteType.Solar:
      return customerSliderSolarHome;
    case EQuoteType.EvCharger:
      return customerSliderEvCharger;
    case EQuoteType.HeatPump:
      return customerSliderHeatPump;
    case EQuoteType.Insulation:
      return customerSliderInsulation;

    default:
      return [];
  }
};

export const customerSliderSolarHome: CustomerSliderType[] = [
  {
    customerMessage:
      "Felt very confident with Swyft from the start, really helped me understand Solar PV. From the online application to the installation, the whole process was very easy. Solar PV has reduced our electricity bills and improved the BER rating in our house.",
    customerName: "Peter O’Mahony,<br/> LIONS, IRELAND AND MUNSTER RUGBY CAPTAIN",
    customerImage: "images/customers/peter.webp"
  },
  {
    customerMessage:
      "With twelve months complete since the installation the results have exceeded expectations and met my objectives. The return on investment, taking into account the grants and accelerated capital allowances, have made this a very good investment.",
    customerName: "PJ O'HALLORAN",
    customerImage: "images/customers/pj.webp"
  }
];

export const customerSliderSolarBusiness: CustomerSliderType[] = [
  {
    customerMessage:
      "The key for me was to reduce our electricity bills and carbon emissions. Swyft helped us achieve this goal with no disruption to the day-to-day operation of our pharmacy. We are very happy to have made the transition to renewable energy.",
    customerName: "Ryders Pharmacy",
    customerImage: "images/customers/ryders.webp"
  }
];

export const customerSliderBoiler: CustomerSliderType[] = [
  {
    customerMessage:
      "From start to finish it was faultless, the staff in the office were so helpful on the phone and getting an installation date was very quick. The engineer doing the install was so efficient and there was very little to clean up considering what a big job it was. I am so happy we went with Swyft would definitely recommend them.",
    customerName: "CATRIONA CRONIN",
    customerImage: "images/customers/catriona.webp"
  }
];

export const customerSliderEvCharger: CustomerSliderType[] = [
  {
    customerMessage: "Placeholder Message",
    customerName: "Placeholder Name",
    customerImage: "images/customers/placeholder.webp"
  }
];

export const customerSliderHeatPump: CustomerSliderType[] = [
  {
    customerMessage: "Placeholder Message",
    customerName: "Placeholder Name",
    customerImage: "images/customers/placeholder.webp"
  }
];

export const customerSliderInsulation: CustomerSliderType[] = [
  {
    customerMessage: "Placeholder Message",
    customerName: "Placeholder Name",
    customerImage: "images/customers/placeholder.webp"
  }
];

export type TypeAftercare = {
  src: string;
  title: string;
  description: string;
};

export const DataAftercare: TypeAftercare[] = [
  {
    src: "images/aftercare/group1.webp",
    title: "Dedicated customer success manager",
    description:
      "If you have any questions or concerns before, during or after your installation, your dedicated Swyft Energy customer success manager will be with you every step of the way."
  },
  {
    src: "images/aftercare/group2.webp",
    title: "Manufacturer warranty support",
    description:
      "Swyft Energy manage your warranty process with the manufacturer of your solar products for the duration of your warranty period, up to 25 years."
  },
  {
    src: "images/aftercare/group3.webp",
    title: "2 year workmanship guarantee ",
    description:
      "All Swyft Energy customers receive a two-year workmanship warranty, meaning your property, solar system and roof are protected."
  },
  {
    src: "images/aftercare/group4.webp",
    title: "Swyft Energy organise your BER",
    description:
      "As part of our SEAI grant management service, we organize your BER assessment for you. If your property reaches a B3 BER rating, you can also apply for a low interest green mortgage!"
  },
  {
    src: "images/aftercare/group5.webp",
    title: "WeSwitchU ",
    description:
      "Swyft Energy have partnered with WeSwitchU, who will set you up with the best energy tariff to maximize your green energy usage and save on your bills."
  },
  {
    src: "images/aftercare/group6.webp",
    title: "Happiness Guaranteed ",
    description:
      "All Swyft Energy customers receive a happiness guarantee meaning if you are not happy with any aspect of your installation we will work with you to make it right. We take our customers happiness and our customer service very seriously. "
  }
];

export type TypeBenefit = {
  src: string;
  title: string;
  description: string;
};

export const DataBenefit: TypeBenefit[] = [
  {
    src: "images/benefit/installer.webp",
    title: "#1 Installer",
    description:
      "With over 12,500+ installations completed to date and an average rating of 4.8/5, Swyft Energy is Ireland's largest and highest rated Solar PV and boiler installer."
  },
  {
    src: "images/benefit/headphone.webp",
    title: "Customer First",
    description:
      "Every Swyft Energy customer receives a dedicated account manager throughout their installation. Our quality team also check every installation to ensure the highest quality standards are met."
  },
  {
    src: "images/benefit/happiness.webp",
    title: "Aftercare Support",
    description:
      "Upgrading your property is a long-term investment and we plan to be with you along the way. We are backed by Ireland's leading investors, such as Enterprise Ireland and Davy/BDO, which means our business will be here long-term should you need us."
  }
];

export const ASSESSMENT_SPECIAL = [
  { product: "Jinko Solar Panels", type: "PDF", size: "1.2MB" },
  { product: "Sonnen Battery", type: "PDF", size: "0.5MB" },
  { product: "Huawei Inverter", type: "PDF", size: "2.1MB" }
];

export const MAX_FINAL_COST = 25000;
export const MIN_FINAL_COST = 4000;
